import { GridFilterModel, GridRowId, GridTreeNode } from '@mui/x-data-grid-pro';
import { ApiRef } from 'components/employee-card/employment/hours-table/HoursTable.types';

export const hasActiveFilter = (model: GridFilterModel) =>
  model.items.some((item) => item.value !== undefined && item.value !== '');

export const isGroupRow = (
  node: GridTreeNode | null | undefined
): node is GridTreeNode => !!node && node.type === 'group';

export const toggleAllGroups = (expand: boolean, apiRef: ApiRef) => {
  if (!apiRef || !apiRef.current) return;

  apiRef?.current?.getAllRowIds().forEach((id: GridRowId) => {
    const node = apiRef?.current?.getRow(id);
    if (isGroupRow(node)) {
      apiRef?.current?.setRowChildrenExpansion(id, expand);
    }
  });
};
